// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
export interface ApiConfig {
  customerApiUrl: string;
  financeiroApiUrl: string;
  loginApiUrl: string;
  pedidoApiUrl: string;
  rastreamentoApiUrl: string;
  destinatarioApiUrl: string;
  atendimentoApiUrl: string;
}

export class APIConfig implements ApiConfig {
  constructor(values: Partial<ApiConfig>) {
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        this['_' + key] = values[key];
      }
    }
  }

  private _customerApiUrl: string;

  public get customerApiUrl(): string {
    return this._customerApiUrl;
  }

  private _financeiroApiUrl: string;

  public get financeiroApiUrl(): string {
    return this._financeiroApiUrl;
  }

  private _loginApiUrl: string;

  public get loginApiUrl(): string {
    return this._loginApiUrl;
  }

  private _pedidoApiUrl: string;

  public get pedidoApiUrl(): string {
    return this._pedidoApiUrl;
  }

  private _rastreamentoApiUrl: string;

  public get rastreamentoApiUrl(): string {
    return this._rastreamentoApiUrl;
  }

  private _destinatarioApiUrl: string;

  public get destinatarioApiUrl(): string {
    return this._destinatarioApiUrl;
  }

  private _atendimentoApiUrl: string;

  public get atendimentoApiUrl(): string {
    return this._atendimentoApiUrl;
  }
}
